// frontend/src/components/GenerateReport.js
import React, { useState } from "react";
import axios from "axios";

const API_BASE_URL = process.env.REACT_APP_FASTAPI_URL;


export default function GenerateReport() {
  const [status, setStatus] = useState("");

  const handleGenerate = async () => {
    setStatus("Generating...");
    try {
      // const res = 
      await axios.post(`${API_BASE_URL}/reports/generate-md`);
      setStatus(`✅ Uploaded Successfully`);
    } catch (err) {
      console.error(err);
      setStatus("❌ Failed to generate");
    }
  };

  return (
    <div>
      <button 
        onClick={handleGenerate}
        className="bg-blue-600 text-white px-4 py-2 rounded"
      >
        Sync Report 
      </button>
      <p>{status}</p>
    </div>
  );
}
